import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

const spacingToRem = (val) => {
  if (typeof val === 'number') return `${val * 0.25}rem`
  return val
}

// eslint-disable-next-line react/display-name
export const AdasBox = forwardRef(
  (
    {
      children,
      className,
      component: Component = 'div',
      style,
      // MUI system props — convert to inline styles to avoid DOM warnings
      display,
      flexDirection,
      alignItems,
      justifyContent,
      gap,
      textAlign,
      width,
      height,
      minHeight,
      maxWidth,
      p,
      px,
      py,
      pt,
      pb,
      pl,
      pr,
      m,
      mx,
      my,
      mt,
      mb,
      ml,
      mr,
      padding,
      overflow,
      flexWrap,
      flexGrow,
      flex,
      position,
      // eslint-disable-next-line no-unused-vars
      sx,
      // eslint-disable-next-line no-unused-vars
      xs,
      ...props
    },
    ref
  ) => {
    const systemStyle = {
      ...(display && { display }),
      ...(flexDirection && (typeof flexDirection === 'string' ? { flexDirection } : {})),
      ...(alignItems && { alignItems }),
      ...(justifyContent && { justifyContent }),
      ...(gap !== undefined && { gap: spacingToRem(gap) }),
      ...(textAlign && { textAlign }),
      ...(width && { width }),
      ...(height && { height }),
      ...(minHeight && { minHeight }),
      ...(maxWidth && { maxWidth }),
      ...(p !== undefined && { padding: spacingToRem(p) }),
      ...(px !== undefined && { paddingLeft: spacingToRem(px), paddingRight: spacingToRem(px) }),
      ...(py !== undefined && { paddingTop: spacingToRem(py), paddingBottom: spacingToRem(py) }),
      ...(pt !== undefined && { paddingTop: spacingToRem(pt) }),
      ...(pb !== undefined && { paddingBottom: spacingToRem(pb) }),
      ...(pl !== undefined && { paddingLeft: spacingToRem(pl) }),
      ...(pr !== undefined && { paddingRight: spacingToRem(pr) }),
      ...(padding !== undefined && { padding: typeof padding === 'number' ? spacingToRem(padding) : padding }),
      ...(m !== undefined && { margin: spacingToRem(m) }),
      ...(mx !== undefined && { marginLeft: spacingToRem(mx), marginRight: spacingToRem(mx) }),
      ...(my !== undefined && { marginTop: spacingToRem(my), marginBottom: spacingToRem(my) }),
      ...(mt !== undefined && { marginTop: spacingToRem(mt) }),
      ...(mb !== undefined && { marginBottom: spacingToRem(mb) }),
      ...(ml !== undefined && { marginLeft: spacingToRem(ml) }),
      ...(mr !== undefined && { marginRight: spacingToRem(mr) }),
      ...(overflow && { overflow }),
      ...(flexWrap && { flexWrap }),
      ...(flexGrow !== undefined && { flexGrow }),
      ...(flex !== undefined && { flex }),
      ...(position && { position }),
      ...style
    }

    return (
      <Component ref={ref} className={cn(className)} style={Object.keys(systemStyle).length > 0 ? systemStyle : undefined} {...props}>
        {children}
      </Component>
    )
  }
)

AdasBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
  style: PropTypes.object
}
